import React, { useContext } from "react";
//
import { useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
// ui
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
// components
import VerticalToolsNav from "../../../../common/components/nav/VerticalToolsNav";
import GroupAvatar from "./GroupAvatar";
// hooks
import useModulePublic from "../../../hooks/useModulePublic";
// style

// store
import { StoreContext } from "../../../../store/StoreProvider";
import Act from "../../../../store/actions";
// config
import { sideToolConfig } from "../../config";
import useLocaleRoute from "../../../../common/hooks/useLocaleRoute";
import urls from "../../../../api/project/ApiUrls";
import IconButtonGen from "../../../../common/components/iconButton/IconButtonGen";

// utils

const getIconButton = ({
  item,
  key,
  handleIconItemClick,
  handleActive,
  handleDisabled,
}) => {
  const intl = useIntl();
  const { name, defaultMessage, iconSrc, iconActiveSrc, intl18Id, className } =
    item;

  return {
    item: (
      <IconButtonGen
        key={key}
        onClick={handleIconItemClick(item)}
        iconSrc={iconSrc}
        iconActiveSrc={iconActiveSrc}
        active={handleActive(item)}
        iconAlt={name}
        variant="square"
        className={className}
        disabled={handleDisabled(item)}
        toolTipTitle={intl.formatMessage({
          id: intl18Id,
          defaultMessage,
        })}
        tooltipPlacement="right"
      />
    ),
  };
};

const SideToolbar = () => {
  const navigate = useNavigate();
  //

  //
  const [state, dispatch] = useContext(StoreContext);
  const { user } = state;
  const { locale } = user;
  const { sidebar } = state.sna;
  // hooks
  const { handlePublic } = useModulePublic();
  const { handleLocaleRoute } = useLocaleRoute(
    locale,
    urls?.locale_lang?.LOCALE_DEFAULT
  );

  const handleIconItemClick = (item) => () => {
    if (item.link) {
      navigate(handleLocaleRoute(item.link));
    } else if (item.name === sidebar.contentName) {
      dispatch({
        type: Act.SNA_SIDE_BAR,
        payload: { ...sidebar, open: !sidebar.open, contentName: item.name },
      });
    } else {
      dispatch({
        type: Act.SNA_SIDE_BAR,
        payload: { ...sidebar, open: true, contentName: item.name },
      });
    }
  };

  const handleActive = (item) => item.name === sidebar.contentName;

  const handleDisabled = (item) => !handlePublic(item.moduleId);

  const topItems = [
    {
      item: (
        <Box mb={2}>
          <GroupAvatar />
        </Box>
      ),
    },
    ...sideToolConfig.topItems.map((item, idx) =>
      getIconButton({
        item,
        key: idx.toString(),
        handleIconItemClick,
        handleActive,
        handleDisabled,
      })
    ),
  ];
  const bottomItems = [
    ...sideToolConfig.bottomItems.map((item, idx) =>
      getIconButton({
        item,
        key: idx.toString(),
        handleIconItemClick,
        handleActive,
        handleDisabled,
      })
    ),
  ];

  return (
    <VerticalToolsNav
      navRoot={{
        sx: {
          paddingY: "20px",
          height: "calc(100vh - 64px)",
          backgroundColor: "#121212",
        },
      }}
      topItems={topItems}
      bottomItems={bottomItems}
    />
  );
};

export default SideToolbar;
